const config = {
    authority: '#{authority}',
    azureClientId: '#{AzureClientId}',
    AdminRole: '#{AdminRole}',
    sharePointTDMUrl: '#{sharePointTDMUrl}',
    sharePointQuery: '#{sharePointQuery}',
    sharePointBaseUrl: '#{sharePointBaseUrl}',
    sharePointImageUrl: '#{sharePointImageUrl}',
    globalTraitServiceUrl: '#{globalTraitServiceUrl}',
    planningServiceURL: '#{planningServiceURL}',
    redirectUrl: '#{REDIRECT_URL}',
    trialPrepUrl: '#{trialPrepUrl}',
    helpDeskUrl: '#{helpDeskUrl}',
    powerBiUrl: '#{powerBiUrl}',
    DYNAMIC_PAGE_BASE_URL: '#{DYNAMIC_PAGE_BASE_URL}',
    BaseName: process.env.PUBLIC_URL === '' ? '/' : process.env.PUBLIC_URL,
    trialAppUrl: '#{trialAppUrl}',
    trialgalleryUrl:'#{tdmGalleryUrl} '
  };
  export default config;
  